import * as airmap from './airmap';
import * as ai from './ai';
import * as assistant from './assistant';
import * as annotations from './annotations';
import * as assessmentType from './assessment-type';
import * as assets from './assets';
import * as auth from './auth';
import * as awsMaps from './aws-maps';
import * as config from '../config';
import * as contracts from './contracts';
import * as credentials from './credentials';
import * as djiIntegration from './dji-integration';
import * as oauthGrants from './oauth-grants';
import * as docs from './docs';
import * as crs from './crs';
import * as equipment from './equipment';
import * as experience from './experience';
import * as geographic from './geographic';
import * as helpers from '../helpers';
import * as job from './job';
import * as jobRequests from './job-requests';
import * as inspection from './inspection';
import * as mission from './mission';
import * as missionSharing from './mission-sharing';
import * as media from './media';
import * as onboarding from './onboarding';
import * as organisation from './organisation';
import * as objectives from './objectives';
import * as organisationUsers from './organisation-users';
import * as organisationMissions from './organisation-missions';
import * as organisationEquipment from './organisation-equipment';
import * as organisationFeatures from './organisation-features';
import * as organisationSeverityScales from './organisation-severity-scales';
import * as transform from './transform';
import * as pilot from './pilot';
import * as plan from './plan';
import * as groundReferences from './ground-references';
import * as s3 from './s3';
import * as sites from './sites';
import * as software from './software';
import * as boralSites from './boral-sites';
import * as volumetric from './volumetric';
import * as volumetrics from './volumetrics';
import * as subscription from './subscription';
import * as tag from './tag';
import * as uppy from './uppy';
import * as user from './user';
import * as userActions from './user-actions';
import * as userTags from './user-tags';
import * as powercorReport from './powercor-report';
import * as processingJobs from './processing-jobs';
import * as missionShareInvitations from './mission-share-invitations';
import * as assessments from './assessments';
import * as maps from './maps';
import * as mapFeatures from './map-features';
import * as mapFolders from './map-folders';
import * as mapSites from './map-sites';
import * as processingJobsV2 from './processing-jobs-v2';
import * as processingJobsV3 from './processing-jobs-v3';
import * as location from './location';

// Export types from maps
export type {
  TableViewPreset,
  TableColumnState,
  TableColumnFilter,
  CreateTablePresetRequest,
  UpdateTablePresetRequest,
  MapSearchLayer,
  MapSearchResult,
  SearchMapsResponse,
  SearchMapsOptions,
  ImportMapLayersBody,
  ProcessingEligibleFolderItem,
  MapVectorTileSignedAccessLayer,
  MapVectorTileSignedAccessResponse,
} from './maps';
export type { VectorSignedPath } from '../config';
export {
  VECTOR_TILE_SIGNATURE_EXPIRED,
  VECTOR_TILE_SIGNATURE_INVALID,
  isVectorTileSignatureExpiredError,
} from './vector-tile-auth';
import * as features from './features';
import * as plansV2 from './plans-v2';
import * as annotationTags from './annotation-tags';
import * as sso from './sso';
import * as stac from './stac';
import * as search from './search';

export type {
  GlobalSearchResult,
  GlobalSearchResultType,
  GlobalSearchResponse,
  GlobalSearchBounds,
  GlobalSearchPin,
  GlobalSearchPinsResponse,
} from './search';

const { fetchTraced } = helpers;
const { fetchAPIAttachment } = helpers;
const { fetchAPIJSON } = helpers;
const { fetchAPI } = helpers;
const { tracer } = helpers;
const { stleaf } = helpers;
const { stroot } = helpers;
const { handle_global_error } = helpers;

export {
  ai,
  assistant,
  annotationTags,
  airmap,
  annotations,
  assessmentType,
  assets,
  auth,
  awsMaps,
  boralSites,
  contracts,
  config,
  credentials,
  crs,
  djiIntegration,
  oauthGrants,
  docs,
  experience,
  equipment,
  fetchTraced,
  fetchAPI,
  fetchAPIJSON,
  fetchAPIAttachment,
  geographic,
  helpers,
  inspection,
  job,
  jobRequests,
  maps,
  mapFeatures,
  mapFolders,
  mapSites,
  mission,
  missionSharing,
  media,
  objectives,
  onboarding,
  pilot,
  plan,
  groundReferences,
  s3,
  sites,
  volumetric,
  volumetrics,
  software,
  subscription,
  tag,
  tracer,
  stleaf,
  stroot,
  handle_global_error,
  user,
  userActions,
  userTags,
  uppy,
  organisation,
  organisationUsers,
  organisationFeatures,
  organisationMissions,
  organisationEquipment,
  organisationSeverityScales,
  transform,
  powercorReport,
  processingJobs,
  missionShareInvitations,
  assessments,
  processingJobsV2,
  processingJobsV3,
  features,
  plansV2,
  sso,
  stac,
  search,
  location,
};

// Re-export STAC types for convenience
export type {
  StacItem,
  StacAsset,
  StacCollection,
  StacItemsResponse,
  StacCollectionsResponse,
  GetStacItemsOptions,
  GetStacCollectionsOptions,
} from './stac';
